import LoadingFallback from "./LoadingFallback";
export * from "./LoadingFallback";
export default LoadingFallback;